'use client';

import { c as _c } from "react/compiler-runtime";
import { Modal, type ModalProps } from '@udemy-v2/react-dialog-components';
import { useFormatNumber, useI18n } from '@udemy-v2/i18n';
import { Button } from '@udemy-v2/react-core-components';
import { ExpressiveIcon, type ExpressiveIconName } from '@udemy-v2/icons-expressive';
import styles from './personal-plan-includes-modal.module.scss';
export interface PersonalPlanIncludesModalProps {
  isOpen: ModalProps['isOpen'];
  onClose: NonNullable<ModalProps['onClose']>;
  courseCount: number;
}
export const PersonalPlanIncludesModal = t0 => {
  const $ = _c(44);
  const {
    isOpen,
    onClose,
    courseCount
  } = t0;
  const {
    gettext,
    interpolate
  } = useI18n();
  const {
    formatNumber
  } = useFormatNumber();
  let t1;
  if ($[0] !== courseCount || $[1] !== formatNumber || $[2] !== gettext || $[3] !== interpolate) {
    t1 = interpolate(gettext("%(courses_count)s+ top-rated courses including AI, web development, data science, and IT"), {
      courses_count: formatNumber(courseCount)
    }, true);
    $[0] = courseCount;
    $[1] = formatNumber;
    $[2] = gettext;
    $[3] = interpolate;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = {
      name: "content",
      text: t1
    };
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== gettext) {
    t3 = gettext("AI-powered soft skills practice through interactive role play scenarios");
    $[7] = gettext;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = {
      name: "soft-skills",
      text: t3
    };
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== gettext) {
    t5 = gettext("Hands-on technical practice through labs and coding exercises");
    $[11] = gettext;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = {
      name: "learning-labs",
      text: t5
    };
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== gettext) {
    t7 = gettext("Comprehensive certification prep for AWS, Microsoft, CompTIA, PMI, and more");
    $[15] = gettext;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = {
      name: "certificate",
      text: t7
    };
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== gettext) {
    t9 = gettext("Ad-free");
    $[19] = gettext;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t9) {
    t10 = {
      name: "marketing",
      text: t9
    };
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t2 || $[25] !== t4 || $[26] !== t6 || $[27] !== t8) {
    t11 = [t2, t4, t6, t8, t10];
    $[23] = t10;
    $[24] = t2;
    $[25] = t4;
    $[26] = t6;
    $[27] = t8;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  const items = t11;
  let t12;
  if ($[29] !== gettext) {
    t12 = gettext("What's included in Personal Plan");
    $[29] = gettext;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== items) {
    t13 = <ul className={styles.list} data-purpose="personal-plan-includes-modal-list">{items.map(_temp)}</ul>;
    $[31] = items;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== gettext) {
    t14 = gettext("Close");
    $[33] = gettext;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== onClose || $[36] !== t14) {
    t15 = <div className={styles.footer}><Button udStyle="primary" onClick={onClose} data-purpose="personal-plan-includes-modal-close">{t14}</Button></div>;
    $[35] = onClose;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== isOpen || $[39] !== onClose || $[40] !== t12 || $[41] !== t13 || $[42] !== t15) {
    t16 = <Modal isOpen={isOpen} onClose={onClose} title={t12} data-purpose="personal-plan-includes-modal">{t13}{t15}</Modal>;
    $[38] = isOpen;
    $[39] = onClose;
    $[40] = t12;
    $[41] = t13;
    $[42] = t15;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  return t16;
};
function _temp(item) {
  return <li key={item.name} className={styles.item}><ExpressiveIcon className={styles.icon} name={item.name} colorScheme="light" size="medium" /><span className={styles.text}>{item.text}</span></li>;
}